/**
 * @flow
 * @relayHash 34f40c2c694b776a49231aea4738b1c6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type LatestWhatIsThis_viewer$ref = any;
export type LatestWhatIsThisQueryVariables = {|
  isIdentityNull: boolean,
  count: number,
  after?: ?string,
|};
export type LatestWhatIsThisQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: LatestWhatIsThis_viewer$ref
  |}
|};
export type LatestWhatIsThisQuery = {|
  variables: LatestWhatIsThisQueryVariables,
  response: LatestWhatIsThisQueryResponse,
|};
*/


/*
query LatestWhatIsThisQuery(
  $isIdentityNull: Boolean!
  $count: Int!
  $after: String
) {
  viewer {
    ...LatestWhatIsThis_viewer_1FlqlG
    id
  }
}

fragment LatestWhatIsThis_viewer_1FlqlG on Query {
  allWhatIsThis(isIdentityNull: $isIdentityNull, first: $count, after: $after) {
    edges {
      node {
        id
        ...WhatIsThis_occurrence
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment WhatIsThis_occurrence on Occurrence {
  id
  where
  when
  notes
  myPerms
  identity {
    id
    ...PlantLink_plant
  }
  images(first: 20) {
    edges {
      node {
        id
        smallImage: image(width: 860, height: 645) {
          url
        }
        ...ImageThumbnail_image
      }
    }
  }
  revisionCreated {
    createdAt
    author {
      avatar(width: 40, height: 40) {
        url
      }
      username
      ...ProfileLink_user
      id
    }
    id
  }
  ...SuggestionsList_occurrence
}

fragment PlantLink_plant on LifeNode {
  id
  idInt
  title
  slug
}

fragment ImageThumbnail_image on Image {
  id
}

fragment ProfileLink_user on User {
  id
  username
  firstName
  reputation
  avatar(width: 40, height: 40) {
    url
  }
}

fragment SuggestionsList_occurrence on Occurrence {
  id
  myPerms
  identity {
    id
    ...PlantLink_plant
  }
  suggestions(first: 100) {
    totalCount
    edgeCount
    edges {
      node {
        id
        ...SuggestionItem_suggestionID
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment SuggestionItem_suggestionID on SuggestionID {
  id
  myPerms
  notes
  author {
    avatar(width: 40, height: 40) {
      url
    }
    username
    ...ProfileLink_user
    id
  }
  identity {
    id
    rankDisplay
    description
    ...PlantLink_plant
  }
  voting {
    ...VotingButtons_voting
    id
  }
  revisionCreated {
    createdAt
    id
  }
}

fragment VotingButtons_voting on Voting {
  id
  countUps
  countDowns
  sumValues
  mine {
    id
    value
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "isIdentityNull",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "isIdentityNull",
  "variableName": "isIdentityNull"
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*: any*/)
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "myPerms",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "idInt",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v10 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  }
],
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "author",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "avatar",
      "storageKey": "avatar(height:40,width:40)",
      "args": [
        {
          "kind": "Literal",
          "name": "height",
          "value": 40
        },
        {
          "kind": "Literal",
          "name": "width",
          "value": 40
        }
      ],
      "concreteType": "File",
      "plural": false,
      "selections": (v10/*: any*/)
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "username",
      "args": null,
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "reputation",
      "args": null,
      "storageKey": null
    }
  ]
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LatestWhatIsThisQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "LatestWhatIsThis_viewer",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "LatestWhatIsThisQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "allWhatIsThis",
            "storageKey": null,
            "args": (v3/*: any*/),
            "concreteType": "OccurrenceConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "OccurrenceEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Occurrence",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "where",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "when",
                        "args": null,
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "identity",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LifeNode",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "images",
                        "storageKey": "images(first:20)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 20
                          }
                        ],
                        "concreteType": "ImageConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ImageEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Image",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": "smallImage",
                                    "name": "image",
                                    "storageKey": "image(height:645,width:860)",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "height",
                                        "value": 645
                                      },
                                      {
                                        "kind": "Literal",
                                        "name": "width",
                                        "value": 860
                                      }
                                    ],
                                    "concreteType": "File",
                                    "plural": false,
                                    "selections": (v10/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "revisionCreated",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Revision",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "suggestions",
                        "storageKey": "suggestions(first:100)",
                        "args": (v13/*: any*/),
                        "concreteType": "SuggestionIDConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "totalCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "edgeCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SuggestionIDEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "SuggestionID",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v6/*: any*/),
                                  (v5/*: any*/),
                                  (v12/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "identity",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "LifeNode",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "rankDisplay",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "description",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "voting",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Voting",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "countUps",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "countDowns",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "sumValues",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "mine",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Vote",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "value",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "revisionCreated",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Revision",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v4/*: any*/)
                                    ]
                                  },
                                  (v14/*: any*/)
                                ]
                              },
                              (v15/*: any*/)
                            ]
                          },
                          (v16/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "suggestions",
                        "args": (v13/*: any*/),
                        "handle": "connection",
                        "key": "Occurrence_suggestions",
                        "filters": null
                      },
                      (v14/*: any*/)
                    ]
                  },
                  (v15/*: any*/)
                ]
              },
              (v16/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "allWhatIsThis",
            "args": (v3/*: any*/),
            "handle": "connection",
            "key": "List_allWhatIsThis",
            "filters": [
              "isIdentityNull"
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "LatestWhatIsThisQuery",
    "id": null,
    "text": "query LatestWhatIsThisQuery(\n  $isIdentityNull: Boolean!\n  $count: Int!\n  $after: String\n) {\n  viewer {\n    ...LatestWhatIsThis_viewer_1FlqlG\n    id\n  }\n}\n\nfragment LatestWhatIsThis_viewer_1FlqlG on Query {\n  allWhatIsThis(isIdentityNull: $isIdentityNull, first: $count, after: $after) {\n    edges {\n      node {\n        id\n        ...WhatIsThis_occurrence\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment WhatIsThis_occurrence on Occurrence {\n  id\n  where\n  when\n  notes\n  myPerms\n  identity {\n    id\n    ...PlantLink_plant\n  }\n  images(first: 20) {\n    edges {\n      node {\n        id\n        smallImage: image(width: 860, height: 645) {\n          url\n        }\n        ...ImageThumbnail_image\n      }\n    }\n  }\n  revisionCreated {\n    createdAt\n    author {\n      avatar(width: 40, height: 40) {\n        url\n      }\n      username\n      ...ProfileLink_user\n      id\n    }\n    id\n  }\n  ...SuggestionsList_occurrence\n}\n\nfragment PlantLink_plant on LifeNode {\n  id\n  idInt\n  title\n  slug\n}\n\nfragment ImageThumbnail_image on Image {\n  id\n}\n\nfragment ProfileLink_user on User {\n  id\n  username\n  firstName\n  reputation\n  avatar(width: 40, height: 40) {\n    url\n  }\n}\n\nfragment SuggestionsList_occurrence on Occurrence {\n  id\n  myPerms\n  identity {\n    id\n    ...PlantLink_plant\n  }\n  suggestions(first: 100) {\n    totalCount\n    edgeCount\n    edges {\n      node {\n        id\n        ...SuggestionItem_suggestionID\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SuggestionItem_suggestionID on SuggestionID {\n  id\n  myPerms\n  notes\n  author {\n    avatar(width: 40, height: 40) {\n      url\n    }\n    username\n    ...ProfileLink_user\n    id\n  }\n  identity {\n    id\n    rankDisplay\n    description\n    ...PlantLink_plant\n  }\n  voting {\n    ...VotingButtons_voting\n    id\n  }\n  revisionCreated {\n    createdAt\n    id\n  }\n}\n\nfragment VotingButtons_voting on Voting {\n  id\n  countUps\n  countDowns\n  sumValues\n  mine {\n    id\n    value\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b1e62de2b3894c1b188d6d83c5b49576';
module.exports = node;
